import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { InProgressApplicationRow } from '../in-progress-application-row.model';

@Component({
  selector: 'app-in-progress-applications-item',
  templateUrl: './in-progress-applications-item.component.html',
  styleUrls: ['./in-progress-applications-item.component.scss'],
  standalone: false
})
export class InProgressApplicationsItemComponent {
  @Input() item: InProgressApplicationRow;

  constructor(private router: Router) {}

  onItemClicked(item: InProgressApplicationRow) {
    if (item.entityType == 'Team') {
      this.router.navigate(['/teams', item.entityId]);
    } else {
      this.router.navigate(['/people/personDetails', item.entityId]);
    }
  }

  onItemKeydown(event: KeyboardEvent, item: InProgressApplicationRow) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onItemClicked(item);
    }
  }
}
